import { HttpClient } from '@angular/common/http';
import { inject, Injectable, Provider } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { Agent, AirlineRule, AirlineRuleRequest, ProviderSupplier } from '../interfaces/airline-rules.interface';

@Injectable({
    providedIn: 'root'
})
export class AirlinesRulesService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl;
    constructor() {}

    getAirlineRules(): Observable<AirlineRule[]> {
        const apiUrl = `${this.baseUrl}/provider-airline-rules`;
        return this.http.get<AirlineRule[]>(apiUrl);
    }

    getAgents(): Observable<Agent[]> {
        const apiUrl = `${this.baseUrl}/agents`;
        return this.http.get<Agent[]>(apiUrl);
    }
    getProviderSuppliers(id: number): Observable<ProviderSupplier[]> {
        const apiUrl = `${this.baseUrl}/provider-suppliers?providerId=${id}`;
        return this.http.get<ProviderSupplier[]>(apiUrl);
    }
    createAirlineRule(ruleRequest: AirlineRuleRequest) {
        const apiUrl = `${this.baseUrl}/provider-airline-rules`;
        return this.http.post(apiUrl, ruleRequest);
    }
    getAirlineRuleById(id: number): Observable<AirlineRule> {
        const apiUrl = `${this.baseUrl}/provider-airline-rules/${id}`;
        return this.http.get<AirlineRule>(apiUrl);
    }
    updateAirlineRule(id: number, ruleRequest: AirlineRuleRequest) {
        const apiUrl = `${this.baseUrl}/provider-airline-rules/${id}`;
        return this.http.put(apiUrl, ruleRequest);
    }
    activateAirlineRule(id: number) {
        const apiUrl = `${this.baseUrl}/provider-airline-rules/${id}/activate`;
        return this.http.patch(apiUrl, null);
    }
    deactivateAirlineRule(id: number) {
        const apiUrl = `${this.baseUrl}/provider-airline-rules/${id}/deactivate`;
        return this.http.patch(apiUrl, null);
    }
}
